angular
    .module('TR')
    .directive('chooseDifferentHotel', function (
        $location: ng.ILocationService,
    ) {
        return {
            scope: {
                changeHotel: '&?',
                dest: '=?'
            },
            templateUrl: 'partials/home/directivetemplate?type=ChooseDifferentHotel',
            link: (scope: ng.IScope) => {

                scope.handleChangeHotel = () => {

                    if (scope.changeHotel) {
                        scope.changeHotel();
                    } else {
                        let breadcrumbTrail = _.get(scope, ['dest', 'BreadcrumbTrail'], []);
                        $location.url(_.get(_.nth(breadcrumbTrail, -2), 'PagePath', '/'));
                    }
                };
            },
            restrict: 'E',
            replace: true,
        };
    });
